import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UnitGlaccountsComponent } from '../unit-glaccounts/unit-glaccounts.component';
import { AccountService } from '../../../services/account.service';
import { Account, AccountGridResponse, GLDefaultRow, gridPageRequest } from '../../../model/common/common.model';


@Component({
  selector: 'app-gl-defaults-lookup',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './gl-defaults-lookup.component.html',
  styleUrl: './gl-defaults-lookup.component.scss'
})

export class GLDefaultsLookupComponent {

  constructor(
    private messageService: MessageService,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private AccountService: AccountService,
    public config: DynamicDialogConfig) { }

  loader: boolean = false;
  allAccounts: any[] = [];
  selectedRow: any;
  accountsByType: { [key: string]: any[] } = {};

  warehouseId!: number;
  warehouseName!: string;
  accountTypeMap: { [key: string]: number } = {};
  allAccountsNew: Account[] = [];


  accountsByTypeCode: { [key: number]: any[] } = {};


  result: AccountGridResponse = {
    account: [],
    totalRecords: 0
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }


  ngOnInit() {
    this.warehouseId = this.config.data?.warehouseId;
    this.warehouseName = this.config.data?.WarehouseName;

    this.loadAllAccounts();
    this.loadExistingGLDefaults();
    this.loadAccountTypes();
    this.loadAccounts();
  }

  gl_defaultsform = new FormGroup({
    AccountsId: new FormControl('', Validators.required),
    Accounts: new FormControl('', Validators.required),
    WarehouseId: new FormControl('', Validators.required),
    Warehouse: new FormControl('', Validators.required),

    IsActive: new FormControl(true),
    CreatedBy: new FormControl('')
  });

  onCancel() {
    this.ref.close(false);
  }


  // getAccountTypeId(accountType: string) {
  //   switch (accountType) {
  //     case 'Assets': return 2205;
  //     case 'Liabilities': return 2206;
  //     case 'Equity': return 2207;
  //     case 'Income': return 2208;
  //     case 'Expenses': return 2209;
  //     default: return null;
  //   }
  // }


  saveGLDefaults() {
    const payload = this.getGLDefaultsPayload();

    this.AccountService.saveOrUpdateGLDefaults(payload).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Saved',
          detail: 'GL Defaults Updated Successfully'
        });

        setTimeout(() => {
          this.ref.close(true);
        }, 1500);

      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to save GL Defaults'
        });
      }
    });
  }

  confirmSaveGLDefaults() {
    this.confirmationService.confirm({
      header: 'Confirm Update',
      message: 'Are you sure you want to Update GL Defaults?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Update',
      rejectLabel: 'Cancel',
      accept: () => {
        this.saveGLDefaults();
      }
    });
  }


  // loadAllAccounts() {
  //   this.loader = true;

  //   this.AccountService.getAllAccounts(this.pageRequest).subscribe({
  //     next: (res: any) => {
  //       console.log(res);

  //       const accounts = res?.account || [];
  //       this.allAccounts = [];
  //       this.accountsByType = {};

  //       for (const acc of accounts) {
  //         if (!acc.accountTypes?.accountType) {
  //           continue;
  //         }
  //         const mappedAcc = {
  //           ...acc,
  //           displayText: `${acc.accountCode} - ${acc.accountName}`
  //         };
  //         this.allAccounts.push(mappedAcc);
  //         const type = acc.accountTypes.accountType;

  //         if (!this.accountsByType[type]) {
  //           this.accountsByType[type] = [];
  //         }
  //         this.accountsByType[type].push(mappedAcc);
  //       }
  //       for (const row of this.glDefaults) {
  //         row.filteredAccounts = this.accountsByType[row.accountType] || [];
  //       }

  //       this.loader = false;
  //     },
  //     error: err => {
  //       this.loader = false;
  //       console.error('Error loading accounts', err);
  //     }
  //   });
  // }

  loadAllAccounts() {
    this.loader = true;

    this.AccountService.getAllActiveAccounts().subscribe({
      next: (res: any[]) => {
        //console.log(res);


        const accounts = res || [];

        // console.log(
        //   accounts
        //     .filter(acc => acc.accountTypes?.accountTypeCode === "20")
        //     .map(acc => acc.accountName)
        // );

        this.allAccounts = [];
        this.accountsByTypeCode = {};

        for (const acc of accounts) {

          const typeCode = acc.accountTypes?.accountTypeCode;
          if (!typeCode) continue;

          const mappedAcc = {
            ...acc,
            displayText: `${acc.accountCode} - ${acc.accountName}`
          };

          this.allAccounts.push(mappedAcc);

          if (!this.accountsByTypeCode[typeCode]) {
            this.accountsByTypeCode[typeCode] = [];
          }

          this.accountsByTypeCode[typeCode].push(mappedAcc);
        }

        for (const row of this.glDefaults) {
          row.filteredAccounts =
            this.accountsByTypeCode[row.accountTypeCode] || [];
        }

        this.loader = false;
      },
      error: err => {
        this.loader = false;
        console.error(err);
      }
    });
  }




  loadExistingGLDefaults() {
    this.AccountService.getGLDefaultsByWarehouse(this.warehouseId)
      .subscribe((res: any[]) => {

        res.forEach(dbRow => {
          const uiRow = this.glDefaults.find(x =>
            x.lineItemNo === dbRow.lineItemNo
          );

          // if (uiRow) {
          //   uiRow.glAccountId = dbRow.accountsId;
          //   uiRow.glAccountName = dbRow.accounts?.accountName;
          // }
          if (uiRow) {
            uiRow.glAccountId = dbRow.accountsId ?? null;
            uiRow.glAccountCode = dbRow.accountsId ? dbRow.accounts?.accountCode : null;
            uiRow.glAccountName = dbRow.accountsId ? dbRow.accounts?.accountName : null;
          }
        });
      });
  }


  getGLDefaultsPayload() {
    const user = localStorage.getItem('username');
    return this.glDefaults.map(row => ({
      WarehouseId: this.warehouseId,
      LineItemNo: row.lineItemNo,
      AccountTypeId: this.getAccountTypeId(row.accountType),
      AccountsId: row.glAccountId ?? null,
      AccountCode: row.glAccountCode ?? null,
      IsActive: true,
      CreatedBy: user,
      UpdatedBy: user
    }));
  }
  onGLAccountClear(row: any) {
    row.glAccountId = null;
    row.glAccountCode = null;
    row.glAccountName = null;

    // 🔹 Force change detection by replacing the array reference
    this.glDefaults = [...this.glDefaults];
  }



  // onGLAccountChange(accountId: number, row: any) {
  //   const selected = this.allAccountsNew.find(
  //     acc => acc.accountsId === accountId
  //   );

  //   if (!selected) {
  //     row.glAccountId = null;
  //     row.glAccountCode = null;
  //     row.glAccountName = null;
  //     return;
  //   }

  //   row.glAccountId = selected.accountsId;
  //   row.glAccountCode = selected.accountCode;
  //   row.glAccountName = selected.accountName;
  // }

  onGLAccountChange(row: any) {
    const selected = row.filteredAccounts?.find((acc: Account) =>
      acc.accountsId === row.glAccountId
    );

    if (selected) {
      row.glAccountCode = selected.accountCode;
      row.glAccountName = selected.accountName;
    } else {
      row.glAccountId = null;
      row.glAccountCode = null;
      row.glAccountName = null;
    }
  }



  glDefaults: GLDefaultRow[] = [

    // ================= ASSETS (8) =================
    { lineItemNo: 1, accountType: 'Assets', accountTypeCode: 10, accountName: 'Cash', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    // { lineItemNo: 2, accountType: 'Assets', accountTypeCode: 10, accountName: 'Petty Cash', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 2, accountType: 'Assets', accountTypeCode: 10, accountName: 'Bank', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 3, accountType: 'Assets', accountTypeCode: 10, accountName: 'Accounts Receivable', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 4, accountType: 'Assets', accountTypeCode: 10, accountName: 'Inventory Asset', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 5, accountType: 'Assets', accountTypeCode: 10, accountName: 'Inventory Adjustment', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 6, accountType: 'Assets', accountTypeCode: 10, accountName: 'Prepaid Expenses', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 7, accountType: 'Assets', accountTypeCode: 10, accountName: 'TDS Receivable', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 8, accountType: 'Assets', accountTypeCode: 10, accountName: 'Vendor Advance', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },

    // ================= LIABILITIES (8) =================
    { lineItemNo: 9, accountType: 'Liabilities', accountTypeCode: 20, accountName: 'Accounts Payable', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 10, accountType: 'Liabilities', accountTypeCode: 20, accountName: 'Customer Advances', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 11, accountType: 'Liabilities', accountTypeCode: 20, accountName: 'Output CGST', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 12, accountType: 'Liabilities', accountTypeCode: 20, accountName: 'Output SGST', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 13, accountType: 'Liabilities', accountTypeCode: 20, accountName: 'Output IGST', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 14, accountType: 'Liabilities', accountTypeCode: 20, accountName: 'TDS Payable', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 15, accountType: 'Liabilities', accountTypeCode: 20, accountName: 'GRNI Clearing Account', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },

    // ================= INCOME (9) =================
    { lineItemNo: 16, accountType: 'Income', accountTypeCode: 40, accountName: 'Sales – Goods (Domestic)', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 17, accountType: 'Income', accountTypeCode: 40, accountName: 'Sales – Export', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 18, accountType: 'Income', accountTypeCode: 40, accountName: 'Sales Revenue', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 19, accountType: 'Income', accountTypeCode: 40, accountName: 'Consulting/Service Income', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 20, accountType: 'Income', accountTypeCode: 40, accountName: 'Discount Received (Purchase)', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 21, accountType: 'Income', accountTypeCode: 40, accountName: 'Freight Income', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 22, accountType: 'Income', accountTypeCode: 40, accountName: 'Rounding Difference - Income', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },

    // ================= EXPENSES (14) =================
    { lineItemNo: 23, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Cost Of Goods Sold', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 24, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Sales Commission', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 25, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Input CGST', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 26, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Input SGST', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 27, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Input IGST', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 28, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Interest Expense', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 29, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Bank Charges', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 30, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Bad Debt Expense', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 31, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Discount Given (Sales)', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 32, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Freight Expense', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 33, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Rounding Difference - Expense', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] },
    { lineItemNo: 34, accountType: 'Expenses', accountTypeCode: 50, accountName: 'Expense Account', glAccountId: null, glAccountCode: null, glAccountName: null, filteredAccounts: [] }

  ];


  showGLAccountLookup(row: any) {
    this.selectedRow = row;

    this.ref = this.dialogService.open(UnitGlaccountsComponent, {
      header: 'Default GL Account List',
      width: '60%',
    });

    this.ref.onClose.subscribe((data: any) => {
      if (data && this.selectedRow) {
        this.selectedRow.glAccountId = data.accountsId;
        this.selectedRow.glAccountCode = data.accountCode;
        this.selectedRow.glAccountName = data.accountName;
        this.selectedRow = null;
      }
    });
  }

  loadAccountTypes() {
    this.AccountService.getAccountTypes().subscribe(data => {
      data.forEach((item: any) => {
        this.accountTypeMap[item.accountType] = item.accountTypeId;
      });
    });
  }

  getAccountTypeId(accountType: string) {
    return this.accountTypeMap[accountType] ?? null;
  }



  loadAccounts() {
    this.AccountService.getAccounts().subscribe(data => {
      this.allAccountsNew = data;
    });
  }

  filterAccountsByType(row: GLDefaultRow) {
    const typeId = this.getAccountTypeId(row.accountType);

    row.filteredAccounts = this.allAccountsNew.filter(
      x => x.accountTypeId === typeId
    );
  }




  //   getGLDefaultsPayload() {
  //   const user = localStorage.getItem('username');

  //   return this.glDefaults
  //     .filter(x => x.glAccountId !== null && x.glAccountId !== undefined)
  //     .map(row => ({
  //       WarehouseId: this.warehouseId,
  //       LineItemNo: row.lineItemNo,
  //       AccountTypeId: this.getAccountTypeId(row.accountType),
  //       AccountsId: row.glAccountId,
  //       IsActive: true,
  //       CreatedBy: user,
  //       UpdatedBy: user
  //     }));
  // }

}
